import React, { useState, useEffect } from "react";
import * as Icon from "lucide-react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { motion, AnimatePresence } from "framer-motion";
import { firestore } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import imagebanner from "./assets/contact/banner.jpg";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

export default function Lienhe() {
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  const toaDoShop = [10.806568671481422, 106.71315486968544];
  const [duLieuForm, setDuLieuForm] = useState({
    ten: "",
    email: "",
    sodt: "",
    noidung: "",
  });
  const [activeInput, setActiveInput] = useState("");
  const [toast, setToast] = useState("");
  const [loading, setLoading] = useState(false);

  const thayDoiInput = (e) => {
    const { name, value } = e.target;
    setDuLieuForm({ ...duLieuForm, [name]: value });
  };

  const guiFormThacMac = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(firestore, "lienhe"), {
        ...duLieuForm,
        createdAt: serverTimestamp(),
      });
      // 🌸 Hiện Toast thành công
      setToast("Cảm ơn bạn. Chúng tôi sẽ phản hồi trong thời gian sớm nhất.");
      setTimeout(() => setToast(""), 4000);
      setDuLieuForm({ ten: "", email: "", sodt: "", noidung: "" });
    } catch (error) {
      console.error("Lỗi gửi dữ liệu:", error);
      // ❌ Hiện Toast lỗi hệ thống
      setToast("Có lỗi xảy ra trong quá trình gửi. Vui lòng thử lại sau!");
      setTimeout(() => setToast(""), 4000);
    } finally {
      setLoading(false);
    }
  };

  const dynamicInputStyle = (name) => ({
    ...stylesLienhe.inputText,
    borderBottomColor: activeInput === name ? "#2C352D" : "#D1D1D1",
  });

  // ================= CẤU HÌNH ANIMATION LUXURY =================
  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.25, // Xuất hiện lần lượt
        delayChildren: 0.2,
      },
    },
  };

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1.2,
        ease: [0.25, 0.1, 0.25, 1], // Easing mượt mà, chậm dần (Luxury feel)
      },
    },
  };

  const mapRevealVariant = {
    hidden: { opacity: 0, x: 50 }, // Trượt nhẹ từ phải sang
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.5,
        ease: [0.25, 0.1, 0.25, 1],
        delay: 0.4,
      },
    },
  };

  return (
    <div style={stylesLienhe.khungTrang}>
      <style>{`
        /* Tinh chỉnh font chữ Serif sang trọng cho tiêu đề */
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&display=swap');
        
        .leaflet-container {
          position: relative;
          width: 100% !important;
          height: 100% !important;
          filter: grayscale(20%) contrast(1.1); /* Làm màu bản đồ deep và classic hơn */
        }
        .leaflet-control-container {
          position: absolute !important;
          top: 16px !important;
          left: 16px !important;
          z-index: 500 !important;
        }
        .leaflet-bar {
          border: none !important;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important;
          border-radius: 0px !important; /* Vuông vức cổ điển */
          overflow: hidden !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
        }
        .leaflet-bar a {
          background-color: #ffffff !important;
          color: #2C352D !important;
          width: 36px !important;
          height: 36px !important;
          line-height: 36px !important;
          font-size: 18px !important;
          text-decoration: none !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          transition: all 0.3s ease !important;
          border: none !important;
        }
        .leaflet-bar a:hover {
          background-color: #F4F5F3 !important;
        }
        .leaflet-top, .leaflet-bottom {
          position: absolute !important;
          z-index: 1000 !important;
          pointer-events: none !important;
        }
        .leaflet-control {
          pointer-events: auto !important;
        }
        /* Custom scrollbar cho textarea */
        textarea::-webkit-scrollbar {
          width: 6px;
        }
        textarea::-webkit-scrollbar-thumb {
          background-color: #D1D1D1;
        }
      `}</style>

      {/* ================= TOAST NOTIFICATION - LIQUID GLASS IOS STYLE ================= */}
      <AnimatePresence>
        {toast && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            style={{
              position: "fixed",
              top: "80px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 9999,
              pointerEvents: "none",
            }}
          >
            <div style={stylesLienhe.toastContainer}>{toast}</div>
          </motion.div>
        )}
      </AnimatePresence>

      <main style={stylesLienhe.noiDungChinh}>
        {/* Cột trái: Nội dung và Form có hiệu ứng Stagger Fade-Up */}
        <motion.div
          style={stylesLienhe.benTraiContent}
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
        >
          <motion.div variants={fadeUpVariant} style={stylesLienhe.headerSection}>
            <h1 style={stylesLienhe.mainTitle}>Liên hệ với Floraison</h1>
            <div style={stylesLienhe.divider}></div>
            <p style={stylesLienhe.subTitle}>
              Hãy để lại lời nhắn, Floraison luôn sẵn lòng lắng nghe và mang đến
              cho bạn những trải nghiệm hoa tươi tinh tế nhất.
            </p>
          </motion.div>

          <motion.div variants={fadeUpVariant} style={stylesLienhe.imageWrapper}>
            <img
              src={imagebanner}
              alt="Floraison Art"
              style={stylesLienhe.decorImage}
              onError={(e) => {
                e.target.style.display = "none";
                e.target.parentElement.style.backgroundColor = "#E5E7E3";
              }}
            />
          </motion.div>

          <motion.div variants={fadeUpVariant} style={stylesLienhe.khoiThongTin}>
            <ul style={stylesLienhe.danhSachInfo}>
              <li style={stylesLienhe.dongInfo}>
                <span style={stylesLienhe.infoLabel}>ĐỊA CHỈ.</span>
                <span style={stylesLienhe.infoText}>
                  15 Đường D5, P. Thạnh Mỹ Tây, TP. HCM
                </span>
              </li>
              <li style={stylesLienhe.dongInfo}>
                <span style={stylesLienhe.infoLabel}>SỐ ĐIỆN THOẠI.</span>
                <span style={stylesLienhe.infoText}>033 878 8804</span>
              </li>
              <li style={stylesLienhe.dongInfo}>
                <span style={stylesLienhe.infoLabel}>EMAIL.</span>
                <span style={stylesLienhe.infoText}>floraison.hoa@gmail.com</span>
              </li>
              <li style={stylesLienhe.dongInfo}>
                <span style={stylesLienhe.infoLabel}>GIỜ LÀM VIỆC.</span>
                <span style={stylesLienhe.infoText}>
                  Mon - Sun | 8:00 A.M. - 17:00 P.M.
                </span>
              </li>
            </ul>
          </motion.div>

          <motion.div variants={fadeUpVariant} style={stylesLienhe.khoiForm}>
            <h2 style={stylesLienhe.formTitle}>Gửi thông điệp</h2>
            <form onSubmit={guiFormThacMac} style={stylesLienhe.formLienHe}>
              <div style={stylesLienhe.formRow}>
                <input
                  type="text"
                  name="ten"
                  placeholder="Tên của bạn *"
                  value={duLieuForm.ten}
                  onChange={thayDoiInput}
                  onFocus={() => setActiveInput("ten")}
                  onBlur={() => setActiveInput("")}
                  required
                  style={dynamicInputStyle("ten")}
                />
                <input
                  type="tel"
                  name="sodt"
                  placeholder="Số điện thoại *"
                  value={duLieuForm.sodt}
                  onChange={thayDoiInput}
                  onFocus={() => setActiveInput("sodt")}
                  onBlur={() => setActiveInput("")}
                  required
                  style={dynamicInputStyle("sodt")}
                />
              </div>
              <input
                type="email"
                name="email"
                placeholder="Email của bạn *"
                value={duLieuForm.email}
                onChange={thayDoiInput}
                onFocus={() => setActiveInput("email")}
                onBlur={() => setActiveInput("")}
                required
                style={dynamicInputStyle("email")}
              />
              <textarea
                name="noidung"
                placeholder="Nội dung lời nhắn..."
                rows="3"
                value={duLieuForm.noidung}
                onChange={thayDoiInput}
                onFocus={() => setActiveInput("noidung")}
                onBlur={() => setActiveInput("")}
                required
                style={{
                  ...stylesLienhe.textareaKhung,
                  borderBottomColor:
                    activeInput === "noidung" ? "#2C352D" : "#D1D1D1",
                }}
              ></textarea>
              <button
                type="submit"
                disabled={loading}
                style={{
                  ...stylesLienhe.nutGuiForm,
                  opacity: loading ? 0.7 : 1,
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                {loading ? "ĐANG GỬI..." : "GỬI YÊU CẦU"}
              </button>
            </form>
          </motion.div>
        </motion.div>

        {/* Cột phải: Bản đồ xuất hiện mượt mà từ bên phải */}
        <motion.div
          style={stylesLienhe.benPhaiBanDoKhuVuc}
          variants={mapRevealVariant}
          initial="hidden"
          animate="visible"
        >
          <div style={stylesLienhe.mapDecorativeFrame}>
            <div style={stylesLienhe.wrapperBanDo}>
              <MapContainer
                center={toaDoShop}
                zoom={16}
                scrollWheelZoom={false}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={toaDoShop}>
                  <Popup>
                    <div
                      style={{
                        fontFamily: "'Playfair Display', serif",
                        fontSize: "16px",
                        color: "#2C352D",
                        textAlign: "center",
                      }}
                    >
                      <strong>Floraison</strong>
                      <br />
                      <span
                        style={{
                          fontSize: "12px",
                          fontFamily: "sans-serif",
                          color: "#666",
                        }}
                      >
                        The Art of Flowers
                      </span>
                    </div>
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
            <div style={stylesLienhe.mapLabel}>
              <Icon.MapPin size={14} style={{ marginRight: "6px" }} />
              FLORAISON STUDIO
            </div>
          </div>
        </motion.div>
      </main>
    </div>
  );
}

const stylesLienhe = {
  khungTrang: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    minHeight: "100vh",
    fontFamily: "system-ui, -apple-system, sans-serif",
    background: "#F9F9F8",
    position: "relative",
    color: "#2C352D",
  },
  toastContainer: {
    position: "absolute",
    zIndex: "9999",
    top: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    willChange: "backdrop-filter, transform",
    transformStyle: "preserve-3d",
    backfaceVisibility: "hidden",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(12px) saturate(180%)",
    WebkitBackdropFilter: "blur(12px) saturate(180%)",
    border: "1px solid rgba(255, 255, 255, 0.25)",
    borderRadius: "50px",
    padding: "14px 28px",
    color: "#000000",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "14px",
    fontWeight: "500",
    letterSpacing: "0.5px",
    textAlign: "center",
    boxShadow:
      "0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 1px rgba(255, 255, 255, 0.2)",
    width: "max-content",
    maxWidth: "85vw",
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: "1.4",
  },
  noiDungChinh: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    width: "100%",
    maxWidth: "1440px",
    background: "#F9F9F8",
    minHeight: "100vh",
  },
  benTraiContent: {
    padding: "80px 10% 80px 15%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "50px",
  },
  headerSection: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  mainTitle: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: "42px",
    fontWeight: "400",
    color: "#1A1A1A",
    margin: 0,
    letterSpacing: "2px",
  },
  divider: {
    width: "60px",
    height: "1px",
    backgroundColor: "#2C352D",
  },
  subTitle: {
    fontSize: "14px",
    color: "#666",
    lineHeight: "1.8",
    maxWidth: "85%",
    margin: 0,
    fontStyle: "italic",
  },
  imageWrapper: {
    width: "100%",
    height: "180px",
    overflow: "hidden",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  decorImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    filter: "brightness(0.95)",
  },
  khoiThongTin: {
    display: "flex",
    flexDirection: "column",
  },
  danhSachInfo: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  dongInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    fontSize: "14px",
  },
  infoLabel: {
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "1.5px",
    color: "#999",
    textTransform: "uppercase",
  },
  infoText: {
    color: "#1A1A1A",
    fontSize: "15px",
    fontFamily: "'Playfair Display', Georgia, serif",
    letterSpacing: "0.5px",
  },
  khoiForm: {
    marginTop: "10px",
  },
  formTitle: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: "22px",
    fontWeight: "400",
    color: "#1A1A1A",
    marginBottom: "30px",
    letterSpacing: "1px",
  },
  formLienHe: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  formRow: {
    display: "flex",
    gap: "30px",
    width: "100%",
  },
  inputText: {
    width: "100%",
    padding: "10px 0",
    border: "none",
    borderBottom: "1px solid #D1D1D1",
    fontSize: "14px",
    background: "transparent",
    transition: "border-color 0.4s ease",
    outline: "none",
    color: "#1A1A1A",
    borderRadius: "0",
    fontFamily: "inherit",
  },
  textareaKhung: {
    width: "100%",
    padding: "10px 0",
    border: "none",
    borderBottom: "1px solid #D1D1D1",
    fontSize: "14px",
    background: "transparent",
    resize: "vertical",
    transition: "border-color 0.4s ease",
    outline: "none",
    color: "#1A1A1A",
    borderRadius: "0",
    fontFamily: "inherit",
    minHeight: "80px",
  },
  nutGuiForm: {
    display: "inline-block",
    alignSelf: "flex-start",
    backgroundColor: "#1A1A1A",
    color: "#ffffff",
    border: "none",
    padding: "16px 45px",
    fontSize: "12px",
    letterSpacing: "2px",
    fontWeight: "600",
    textTransform: "uppercase",
    transition: "all 0.3s ease",
    marginTop: "10px",
    borderRadius: "0",
  },
  benPhaiBanDoKhuVuc: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 10% 60px 5%",
    background: "#F0F1EE",
  },
  mapDecorativeFrame: {
    width: "100%",
    height: "85%",
    minHeight: "600px",
    position: "relative",
    padding: "15px",
    background: "#ffffff",
    boxShadow: "0 20px 50px rgba(0,0,0,0.05)",
  },
  wrapperBanDo: {
    width: "100%",
    height: "100%",
    position: "relative",
    zIndex: 1,
  },
  mapLabel: {
    position: "absolute",
    bottom: "-20px",
    right: "40px",
    background: "#1A1A1A",
    color: "#ffffff",
    padding: "12px 24px",
    fontSize: "11px",
    letterSpacing: "2px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    zIndex: 2,
    boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
  },
};